import { configureStore, getDefaultMiddleware } from '@reduxjs/toolkit'
import rootReducer from './rootReducer'
import logger from 'redux-logger'
import localForage from 'localforage'
import { persistStore, persistReducer } from 'redux-persist'
import expireReducer from 'redux-persist-expire'

const prodMiddleware = []
const devMiddleware = [logger]

let middleware = [...getDefaultMiddleware(), ...prodMiddleware]

if (process.env.NODE_ENV !== 'production') {
    middleware = [...middleware, ...devMiddleware]
}

const persistConfig = {
    key: 'root',
    storage: localForage,
    whitelist: ['user', 'cart', 'wizard', 'recentlyViewed'],
    transforms: [
        expireReducer('user', {
            expireSeconds: 86400, //Expire after 1 day
            expiredState: {
                isLoggedIn: false,
                userDetails: {},
            },
            autoExpire: true,
        }),
    ],
}

const persistedReducer = persistReducer(persistConfig, rootReducer)

export const store = configureStore({
    reducer: persistedReducer,
    middleware,
})

export const persistor = persistStore(store)
